import { render, staticRenderFns } from "./stardisplay.vue?vue&type=template&id=dd4a7ace&"
import script from "./stardisplay.vue?vue&type=script&lang=js&"
export * from "./stardisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd4a7ace')) {
      api.createRecord('dd4a7ace', component.options)
    } else {
      api.reload('dd4a7ace', component.options)
    }
    module.hot.accept("./stardisplay.vue?vue&type=template&id=dd4a7ace&", function () {
      api.rerender('dd4a7ace', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2gNK8t62JzWNO/JS/comp/stardisplay.vue"
export default component.exports